import type { PrivateUserInfoType } from '@otw/models'
import { getUserDisplayName } from 'hooks/useUsers'

/** Name of the inventory rep assigned to an inventory lead. */
export const resolveInventoryRepName = (
  users: PrivateUserInfoType[],
  assignedRepId: string | null | undefined,
): string => {
  if (!assignedRepId) return 'Unassigned'
  const rep = users.find((user) => String(user.id) === String(assignedRepId))
  return rep ? getUserDisplayName(rep) : 'Unknown'
}
